import axiosInstance from "../axiosInstance";

export const getServices = async () => {
  try {
    const response = await axiosInstance.get("/api/service");
    return {
      success: true,
      data: response?.data?.data || response?.data || [],
      message: response?.data?.message || "Services fetched successfully",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to fetch services",
      status: error.response?.status || 500,
    };
  }
};

